import React from 'react'
import { useHover } from '../../../hooks/useHover'
import { getRGB } from '../../../../lib/color';
import { darkenColor, lightenColor } from '../helpers';

const LineTabButton = ({ handleOnClick, children, activeTab, tab, color }) => {
    const { isHover, onMouseEnter, onMouseLeave } = useHover();
    const activeColor = getRGB(color);
    const hoverColor = lightenColor(color, 0.05);
    const hoverActiveColor = darkenColor(color, 0.1);
    const isActive = activeTab === tab;

    let tabColor = '#404040';

    switch(true) {
        case isActive && isHover:
            tabColor = hoverActiveColor;
            break;
        case isActive:
            tabColor = activeColor;
            break;
        case isHover:
            tabColor = hoverColor;
            break;
        default:
            tabColor = '#404040';
            break;
    }

    const tabStyle = {
        color: tabColor,
        fontWeight: 'bold',
        cursor: 'pointer'
    }

    return (
        <div style={tabStyle} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={handleOnClick}>
            {children}
        </div>
    )
}

export default LineTabButton